import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Eye, EyeOff } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      {/* Left side - Corporate Buildings Image */}
      <div
        className="hidden lg:block relative bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1722299548097-d25f4440879f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBidWlsZGluZ3MlMjBidXNpbmVzcyUyMHNreXNjcmFwZXJzfGVufDB8fHx8MTc3NDkzNTg5M3ww&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#1F3864]/90 to-[#0f172a]/80"></div>
        <div className="relative z-10 flex flex-col justify-center h-full px-16 text-white">
          <h1 className="text-6xl font-bold tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>
            AS CONSULTING SAS
          </h1>
          <p className="text-2xl text-gray-200 leading-relaxed font-light">
            Firma contable
          </p>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className="flex items-center justify-center bg-white px-8 py-12">
        <div className="w-full max-w-md space-y-8">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_contador-profesional/artifacts/u6a4cz89_AS%20CONSULTING%20%282%29.png" 
              alt="AS CONSULTING SAS" 
              className="h-32 w-auto"
            />
          </div>

          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Outfit' }}>
              ¡Somos tu mejor aliado!
            </h2>
            <p className="mt-2 text-sm text-slate-600">Ingresa a tu cuenta</p>
          </div>

          <form onSubmit={handleSubmit} className="mt-8 space-y-6" data-testid="login-form">
            <div className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-xs font-semibold tracking-wider uppercase text-slate-500">
                  Correo Electrónico
                </Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder=""
                  className="mt-1"
                  data-testid="email-input"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-xs font-semibold tracking-wider uppercase text-slate-500">
                  Contraseña
                </Label>
                <div className="relative mt-1">
                  <Input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder=""
                    className="pr-10"
                    data-testid="password-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                    data-testid="toggle-password-visibility"
                    tabIndex={-1}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3" data-testid="error-message">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1F3864] hover:bg-[#172b4d] text-white rounded-md px-4 py-2 transition-colors"
              data-testid="login-submit-button"
            >
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
